/**
 * Constants for records UI display and descriptions
 */

export const PDF_ORDER_KEY = 'purchasedPdfs'

// PDF Access Types
export const PDF_ACCESS_TYPES = {
  NONE: 1,
  ONEDAY_BY_PRINT: 2,
  ONEDAY_BY_PURCHASE: 3,
  UNLIMITED: 4,
  UNLIMITED_PREMIUM_MEMBERSHIP: 5
} as const

// Define record keys as the source of truth
export const RECORD_KEYS = [
  'full-record-package',
  'messaging',
  'calendar',
  'journal',
  'calling',
  'payments',
  'info-library',
  'messaging-single',
  'calling-single'
] as const

export type RecordKey = (typeof RECORD_KEYS)[number]

// Record descriptions for UI display (based on the keys)
export const RECORD_DESCRIPTIONS: Record<
  RecordKey,
  readonly { contentKey: string; tier: number }[]
> = {
  'full-record-package': [
    { contentKey: 'records.card.package.0', tier: 0 },
    { contentKey: 'records.card.package.1', tier: 0 },
    { contentKey: 'records.card.package.2', tier: 0 }
  ],
  messaging: [
    { contentKey: 'records.card.messaging.0', tier: 0 },
    { contentKey: 'records.card.messaging.1', tier: 0 },
    { contentKey: 'records.card.messaging.2', tier: 0 }
  ],
  calendar: [
    { contentKey: 'records.card.calendar.0', tier: 0 },
    { contentKey: 'records.card.calendar.1', tier: 0 }
  ],
  journal: [
    { contentKey: 'records.card.journal.0', tier: 0 },
    { contentKey: 'records.card.journal.1', tier: 0 }
  ],
  calling: [
    { contentKey: 'records.card.calling.0', tier: 0 },
    { contentKey: 'records.card.calling.1', tier: 2 }
  ],
  payments: [
    { contentKey: 'records.card.payments.0', tier: 0 },
    { contentKey: 'records.card.payments.1', tier: 0 },
    { contentKey: 'records.card.payments.2', tier: 0 }
  ],
  'info-library': [
    { contentKey: 'records.card.info.0', tier: 0 },
    { contentKey: 'records.card.info.1', tier: 0 }
  ],
  'messaging-single': [
    { contentKey: 'records.card.messaging.0', tier: 0 },
    { contentKey: 'records.card.messaging.1', tier: 0 },
    { contentKey: 'records.card.messaging.2', tier: 0 }
  ],
  'calling-single': []
} as const

// Record order numbers for display sorting
export const RECORD_ORDER_NUMS: Record<RecordKey, number> = {
  'full-record-package': 1,
  messaging: 2,
  calendar: 3,
  journal: 4,
  calling: 5,
  payments: 6,
  'info-library': 7,
  'messaging-single': 8,
  'calling-single': 8
} as const

// Availability error messages
export const AVAILABILITY_MESSAGES = {
  messaging: { new: 'records.orderRecords.unavailable.messaging.new' },
  calendar: {
    none: 'records.orderRecords.unavailable.calendar.none',
    new: 'records.orderRecords.unavailable.calendar.new'
  },
  journal: { none: 'records.orderRecords.unavailable.journal.none' },
  calling: {
    none: 'records.orderRecords.unavailable.calling.none',
    new: 'records.orderRecords.unavailable.calling.new'
  },
  'info-library': {
    none: 'records.orderRecords.unavailable.infoLibrary.none',
    new: 'records.orderRecords.unavailable.infoLibrary.new'
  },
  payments: { new: 'records.orderRecords.unavailable.payments.new' },
  'full-record-package': { new: 'records.orderRecords.unavailable.package.new' }
} as const
